document.addEventListener('DOMContentLoaded', function () {
  const summaries = document.querySelectorAll('.faq-list details.faq-item > summary');
  summaries.forEach(summary => {
    summary.addEventListener('click', function(event) {
      event.preventDefault(); // Previene il comportamento nativo
      const detail = this.parentElement;
      
      // Se non è aperto, chiudi gli altri e apri quello corrente
      if (!detail.open) {
        document.querySelectorAll('.faq-list details.faq-item[open]').forEach(otherDetail => {
          otherDetail.removeAttribute('open');
        });
        detail.setAttribute('open', 'open');
      } else {
        detail.removeAttribute('open');
      }
    });
  });
});
